import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FormattedMessage as T } from "react-intl";
import UserAuditLogTable from "./UserAuditLogTable";

type UserAuditLogAccordionProps = {
  userId: string;
};

export const UserAuditLogAccordion = ({
  userId,
}: UserAuditLogAccordionProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>
          <T id="audit" />
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box mb={2}>
          {expanded && <UserAuditLogTable userId={userId} />}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
